import { useContext } from 'react';

import { AuthenticationContext, AuthenticationProvider } from './auth-provider';

const useAuth = () => {
  const context = useContext(AuthenticationContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within AuthenticationProvider');
  }
  return context;
};

export default AuthenticationProvider;
export { AuthenticationContext, useAuth };
